import { Button } from "@/components/button";
import styled from "@emotion/styled";

export const CustomButton = styled(Button)`
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.black};

    &:hover {
        background: ${({ theme }) => theme.COLOR.text[300]};
    }
`;
